import { _decorator, UITransform } from 'cc';

import BaseAutoHiding from '../ScrollView/BaseAutoHiding';

const { ccclass, requireComponent } = _decorator;

@ccclass('AutoHidingUITransform')
@requireComponent(UITransform)
export default class AutoHidingUITransform extends BaseAutoHiding {
    protected get viewUTransform(): UITransform {
        return this.node.transform;
    }
}
